import { useEffect, useState } from 'react';
import useGetItemsList from '../../../../hooks/INV/MasterItems/useGetItemsList';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  getItemsBySupplierId,
  DeleteItemSupplier,
  //   ItemSupplierInItem,
  AddItemSupplier,
} from '../../../../store/INV/AssignmentItems/itemsSupplierSlice';
import Loading from '../../../../components/Shared/Loader/Loading';
import confirmAction from '../../../../components/Shared/Alert/confirmAction';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import NtxTable from '../../../../components/DataTable/NtxTable';

type Props = {
  peopleId: string | undefined;
};

const SupplierItems = ({ peopleId }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [itemid, setItemid] = useState<string | null>('');

  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const { ItemsOptions, loading, error } = useGetItemsList();

  useEffect(() => {
    if (peopleId) {
      dispatch(getItemsBySupplierId(peopleId));
    }
    setItemid('');
  }, [dispatch, peopleId]);

  const { loading: loading2, error: error2 } = useAppSelector((s) => s.itemsSupplier);

  const onAdd = () => {
    setIsSubmitting(true);

    const body = {
      itemId: itemid,
      supplierId: peopleId,
    };

    dispatch(AddItemSupplier(body))
      .unwrap()
      .then((res) => {
        if (res.succeeded) {
          CustomAlert({ action: 'Add' });
          dispatch(getItemsBySupplierId(peopleId || ''));
        } else {
          CustomAlert({ action: 'Error', msg: res.message });
        }
      })
      .catch((error: any) => {
        CustomAlert({ action: 'Error' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  //   console.log(itemid);

  return (
    <>
      <Loading loading={loading || loading2} error={error || error2} Type="Dots">
        <div className="input-group flex-nowrap align-items-center mb-2">
          <span className="input-group-text fw-bold  px-3">{t('الصنف')}</span>

          <Select
            classNamePrefix="react-select"
            className="flex-grow-1 me-2"
            isSearchable
            isClearable
            options={ItemsOptions}
            onChange={(option) => setItemid(option === null ? null : option.value)}
            placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                borderRadius: '0.375rem',
                borderColor: '#ced4da',
                boxShadow: 'none',
                ':hover': { borderColor: '#86b7fe' },
              }),
            }}
          />

          <button
            disabled={isSubmitting || !itemid}
            type="button"
            className="btn btn-theme d-flex align-items-center px-3 rounded-0"
            onClick={onAdd}>
            {isSubmitting ? (
              <div className="spinner-border spinner-border-sm me-2"></div>
            ) : (
              <i className="fas fa-plus fa-lg fa-fw me-2"></i>
            )}
            {t('Add')}
          </button>
        </div>

        <List peopleId={peopleId} />
      </Loading>
    </>
  );
};

export default SupplierItems;

const List = ({ peopleId }: Props) => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const { ItemsBySupplier } = useAppSelector((s) => s.itemsSupplier);

  const handleDelete = async (itemId: any) => {
    const isConfirm = await confirmAction('هل أنت متأكد من عملية الحذف');
    if (!isConfirm) {
      return;
    }
    dispatch(
      DeleteItemSupplier({
        itemId: itemId,
        supplierId: peopleId,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(getItemsBySupplierId(peopleId || ''));
        CustomAlert({ action: 'Delete' });
      })
      .catch((error) => {
        CustomAlert({ action: 'Error' });
      });
  };

  const columns = [
    { title: t('Name'), key: 'item' },
    { title: '', key: 'action', className: 'text-end' },
  ];

  const tableData =
    ItemsBySupplier?.map((item) => {
      let rowClass;

      return {
        item: i18n.language === 'en' ? item.itemName : item.itemName2,
        action: (
          <button
            type="button"
            className="btn  btn-outline-danger"
            onClick={() => handleDelete(item.itemId)}>
            <i className="fas fa-lg fa-trash-alt"></i>
          </button>
        ),
      };
    }) || [];

  return (
    <>
      <NtxTable
        data={tableData || []}
        columns={columns || []}
        dataPerPage={5}
        theadClass=""
        tableClass="table text-nowrap table-hover "
      />
    </>
  );
};
